<template>
  <b-modal id="updateCallLogModal" ref="updateCallLogModal" size="xs" hide-footer @hidden="$emit('reset')">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('views.excmcalllog.list.setRelatedUserData') }}</h6>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="form-group">
          <label class="form-control-label">{{ $t('views.financialreport.list.contractor') }}:</label><br>
          <base-select-input
              v-model="updateCallLog.idRelatedUserData"
              :search-callback="userDataSearchCallback"
              :display-values="['fullName', 'firmname1']"
              :query-param="'userdata'"
              :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-button class="btn float-left btn-info mr-1" @click="updateItem()">{{ $t('buttons.submit') }}</b-button>
        <b-button class="btn float-left btn-danger" @click="hideModal()">{{ $t('buttons.cancel') }}</b-button>
      </b-col>
    </b-row>
  </b-modal>
</template>
<script>
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
export default {
  name: 'updateCallLogRelatedUserDataModal',
  components: { BaseSelectInput },
  props: {
    updateCallLog: {}
  },
  mounted () {
    if (this.updateCallLog) {
      this.$refs.updateCallLogModal.show()
    }
  },
  methods: {
    hideModal () {
      this.$refs.updateCallLogModal.hide()
      this.$emit('reset')
    },
    resetUpdateCallLog () {
      this.$emit('reset', true)
    },
    async updateItem () {
      const response = await new ApiService(this.updateCallLog['@id']).put(this.updateCallLog)
      if (response.status === 200) {
        this.resetUpdateCallLog()
      }
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  }
}
</script>
